export function getTypedKeys<T extends object>(obj: T) {

  return Object.keys(obj) as Array<string & keyof T>;

}
